// extracted by mini-css-extract-plugin
export var badge = "_ik-2";
export var detailsPanel = "_ik-0";
export var resultRow = "_ik-1";